import { BaseState } from '@core/state-management/base.state';
import { StateResetFilter } from '@core/state-management/state-reset.service';

export class BcmBaseState<Entity> extends BaseState<Entity> {
    constructor(uniqueIdentAttribute: string) {
        super(StateResetFilter.BCM, uniqueIdentAttribute);
    }
}
